import { createContext, useContext, type Dispatch, type SetStateAction } from 'react'
import type { Edge, Node } from 'reactflow'

export type PipelineFlowStateContextValue = {
  setNodes: Dispatch<SetStateAction<Node[]>>
  setEdges: Dispatch<SetStateAction<Edge[]>>
  removeNodeAndConnectedEdges: (nodeId: string) => void
}

export const PipelineFlowStateContext = createContext<PipelineFlowStateContextValue | null>(null)

export function usePipelineFlowState(): PipelineFlowStateContextValue {
  const ctx = useContext(PipelineFlowStateContext)
  if (!ctx) {
    throw new Error('usePipelineFlowState must be used within PipelineFlowStateContext.Provider')
  }
  return ctx
}
